export class PlanHelper
{
    public static GetPlanDisplayName(slug: string | null): string
    {
        switch (slug)
        {
            case 'free':
                return 'Free Plan';
            case 'starter':
                return 'Starter Plan';
            case 'pro':
                return 'Pro Plan';
            default:
                return 'Unknown Plan';
        }
    }

    public static GetPlanId(slug: string | null): number | null
    {
        switch (slug)
        {
            case 'free':
                return null;
            case 'starter':
                return 1;
            case 'pro':
                return 2;
            default:
                return null;
        }
    }

    public static GetPlanMessagesPerMonth(slug: string | null): number | null
    {
        switch (slug)
        {
            case 'free':
                return 10;
            case 'starter':
                return 50;
            case 'pro':
                return null;
            default:
                return null;
        }
    }
}
